import * as React from "react"
import MainVisual from "./components/MainVisual"
import Footer from "../Home/components/Footer"
import About from "../Home/components/About"
import { Button } from "@material-ui/core"
import { GAEvent } from "../../modules/GoogleAnalytics"
import useLoginPopup from "../../hooks/useLoginPopup"
import { useTrack } from "@hackler/react-sdk"
import Description from "./components/Description"
import DataSample from "./components/DataSample"
import CreateFunnelSample from "./components/CreateFunnelSample"
import FunnelEffect from "./components/FunnelEffect"
import { useEffect } from "react"
import { FormattedMessage } from "react-intl"
import SDKIntegration from "../../components/SDKIntegration"

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL
export default function Funnel() {
  const track = useTrack()
  const loginPopup = useLoginPopup()

  useEffect(() => {
    track({ key: "homepage_funnel_view" })
  }, [])

  return (
    <>
      <MainVisual />
      <Description />
      <DataSample />
      <CreateFunnelSample />
      <FunnelEffect />
      <SDKIntegration />
      <About
        pageName="funnel"
        serviceButtonComponent={({ isMobile, className }) => (
          <Button
            color={"inherit"}
            variant={"contained"}
            fullWidth={isMobile}
            className={className}
            onClick={() => {
              GAEvent({
                category: "funnel-6",
                action: "click",
                label: "start funnel",
              })
              track({ key: "homepage_all_funnel_start_click" })
              track({ key: "homepage_funnel_about_funnel_start_click" })
              loginPopup(`${dashboardUrl}/funnels`)
            }}>
            <strong>
              <FormattedMessage id={"funnel_start_btn"} />
            </strong>
          </Button>
        )}
      />
      <Footer pageName={"funnel"} />
    </>
  )
}
